export default __webpack_public_path__ + "static/media/AddRefMob.8247bd29.svg";